import { TranslateService } from '@ngx-translate/core';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog';

@Injectable({
  providedIn: 'root'
})
export class ComponentCommunicationService {

  public changeSum: EventEmitter<any> = new EventEmitter<any>();
  public latestSumInsured: number;

  constructor(private dialogRef: MatDialog, private translateService: TranslateService) {
    this.changeSum.subscribe(result => {
      this.latestSumInsured = result;
    });
  }

  public loadDialog(infoValue: string, translateParam?: string): void {
    const dialogRef = this.dialogRef.open(ConfirmationDialogComponent);
    if (translateParam) {
      dialogRef.componentInstance.data = { title: infoValue, translateParam };
    } else {
      dialogRef.componentInstance.data = infoValue;
    }
  }

  public getDateFormat(): string {
    if (this.translateService.currentLang === 'en') {
      return '00/00/0000';
    }
    return '00-00-0000';
  }

}
